<template>
  <div>
    <transition name="slideAnim" type="animation" appear mode="out-in">
      <div style="text-align:center; margin-bottom:30px; margin-top:100px">
        <arkidian
          style="margin:auto; background-color:#ececec; border-radius:50%; width:200px; margin-top:100px; margin-bottom:40px "
          :preferencias="preferencias"
        ></arkidian>
        <b-button
          v-if="!preferencias.body"

          style="margin:auto; background-color:rgba(0, 0, 0, 0);border:0; border-radius:50%; width:200px; height:200px; margin-top:-270px; margin-bottom:40px "
          @click="crearArkidian()"
        >{{preferencias.body}}
        <img src="public/images/site/edit.svg" width=100 height=100>
        </b-button>


        <h3 class="alias">Hola {{userLogged.name}}</h3>

      </div>
    </transition>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import Arkidian from "../shared/Arkidian";

export default {
  data: function() {
    return {
      perfil: "",
      preferencias: {
        color: "",
        body: "",
        face: "",
        hair: "",
        avatar: "",
        animated: false
      }
    };
  },
  computed: {
    ...mapGetters(["categorias", "userLogged", "pathAPI"])
  },
  methods: {
    buscarPerfil() {
      var self = this;
      fetch(self.pathAPI + "perfil_usuario.php?usuario=" + self.userLogged.user)
        .then(response => response.json())
        .then(data => {
          self.perfil = data;
        });
    },
    crearArkidian() {
      this.$router.push({ path: "/Avatar" });
    }
  },
  mounted: function() {
    console.log("Welcome mounted");
    this.buscarPerfil();
    this.preferencias.color = this.userLogged.preferencias.color;
    this.preferencias.body = this.userLogged.preferencias.body;
    this.preferencias.face = this.userLogged.preferencias.face;
    this.preferencias.hair = this.userLogged.preferencias.hair;
    this.preferencias.avatar = this.userLogged.preferencias.avatar;
    this.preferencias.animated = true;
  },
  components: {
    arkidian: Arkidian
  }
};
</script>

<style scoped>
.alias {
  background: rgb(236, 236, 236);
  border-radius: 30px;
  margin: auto;
  width: 300px;
}
</style>


// WEBPACK FOOTER //
// src/components/startPage/Welcome.vue